import moment from "moment";
import { useRef, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Post from "../../api/Post";
import {
  ADD_APPOINTMENT,
  PARTNER_GET_ACTIVE_SIN_TOKEN,
  TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
} from "../../api/Routes";
import SimpleLoad from "../../loader/SimpleLoad";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import * as Yup from "yup";
import { Field, Formik } from "formik";
import { getTokenExternal } from "../../utils/getTokenExternal";
import { getSource } from "../../utils/getSource";
import ConsentimientoTeleSalud from "./ConsentimientoTeleSalud";
import ModalInformacionParaPago from "../pagos/ModalInformacionParaPago";
import { useEffect } from "react";
import useGetNameAccount from "../../hook/useGetNameAccount";
import SignatureCanvas from "react-signature-canvas";
import Get from "../../api/Get";
import { ModalHandleDeclinado } from "../cita/ModalHandleDeclinado";

function StepTreeCuenta({
  t,
  next,
  initialData,
  prev,
  setReservadoExitosamente,
  reservadoExitosamente,
  isPedienteAprobacion,
  source,
  idAccount,
  setPayment,
  setPaymentStatus,
  configuration,
  setDeclined,
}) {
  const nameAccount = useGetNameAccount(idAccount);
  const [show, setShow] = useState(false);
  const [isSubmitting, setIsSubmiting] = useState(false);
  const [checkedTerms, setCheckedTerms] = useState(false);
  const [errorServer, setErrorServer] = useState(null);
  const [showModalServer, setShowModalServer] = useState(false);
  const [choiceTypeInput, setChoiceTypeInput] = useState("");
  const sourceObj = getSource(source);
  const [openModalPago, setOpenModalPago] = useState(false);
  const [hasCopayment, setHasCopayment] = useState(
    initialData.account.hasCopayment ?? false
  );
  const [objPayment, setObjPayment] = useState(null);
  const [citaCostoMoneda, setCitaCostoMoneda] = useState({
    costo: null,
    currency: "",
  });
  const [errors, setErrors] = useState({
    firma: {
      error: false,
      text: "",
    },
    identityDocumentType: {
      error: false,
      text: "",
    },
    documentNumber: {
      error: false,
      text: "",
    },
    fullName: {
      error: false,
      text: "",
    },
    patientRelationship: {
      error: false,
      text: "",
    },
  });
  const sigCanvas = useRef({});
  const [aceptacionAcudiente, setAceptacionAcudiente] = useState(false);
  const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([]);
  const [identityDocumentType, setIdentityDocumentType] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [tipoPacientes, setTipoPacientes] = useState([]);
  const [patientRelationship, setPatientRelationship] = useState("");
  const [dataRecord, setDataRecord] = useState("");
  const clear = () => sigCanvas.current.clear();

  const [failPayment, setFailPayment] = useState(false);
  //console.log(initialData)
  useEffect(() => {
    const idEspecialidad = initialData.especialidadId;
    const especilidadDetail = initialData.account?.specialtyDurationList.filter(
      (item) => item.especialty?.id === parseInt(idEspecialidad)
    );
    let hasCopaymentEspeciality = false;
    if (especilidadDetail.length) {
      hasCopaymentEspeciality = especilidadDetail[0].hasCopayment ?? false;
      const costo = especilidadDetail[0].amountPayment ?? null;
      const currency = especilidadDetail[0].currency?.code ?? null;
      setCitaCostoMoneda({
        costo: costo,
        currency: currency,
      });
    }
    setHasCopayment(
      initialData.account.hasCopayment && hasCopaymentEspeciality
    );
  }, []);

  const fetchTipoDocumentoApi = async () => {
    try {
      const response = await Get({
        url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
        noToken: true,
      });
      setTipoDocumentoOpt(response.data);
    } catch (error) {
      setTipoDocumentoOpt([]);
    }
  };
  const fetchTipoPacienteApi = async () => {
    try {
      const response = await Get({
        url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${initialData.account.id}`,
        noToken: true,
      });
      setTipoPacientes(response.data.data.response);
    } catch (error) {
      setTipoPacientes([]);
    }
  };

  useEffect(() => {
    fetchTipoDocumentoApi();
    fetchTipoPacienteApi();
  }, []);

  const handleCloseModalServer = () => {
    setShowModalServer(false);
  };

  const handleClose = () => setShow(false);

  const shemaValidateStepOne = Yup.object().shape({
    choiceType: Yup.string().required(t("Camporequerido")),
  });
  const [allowDoAppt, setAllowDoAppt] = useState(true);
  const handleMakeAppointment = (confirmado) => {
    //console.log('aprovado '+confirmado)
    if (confirmado) {
      if (checkedTerms) {
        //checamos campos requeridos
        let doAppt = allowDoAppt;
        if (sigCanvas.current.isEmpty() || aceptacionAcudiente) {
          const errorCopy = { ...errors };
          if (sigCanvas.current.isEmpty()) {
            errorCopy.firma.error = true;
            errorCopy.firma.text = "Firma requerida";
            doAppt = false;
          } else {
            errorCopy.firma.error = false;
            errorCopy.firma.text = "";
          }
          if (fullName === "") {
            errorCopy.fullName.error = true;
            errorCopy.fullName.text = "Campo requerido";
            doAppt = false;
          } else {
            errorCopy.fullName.error = false;
            errorCopy.fullName.text = "";
          }
          if (documentNumber === "") {
            errorCopy.documentNumber.error = true;
            errorCopy.documentNumber.text = "Campo requerido";
            doAppt = false;
          } else {
            errorCopy.documentNumber.error = false;
            errorCopy.documentNumber.text = "";
          }
          if (patientRelationship === "") {
            errorCopy.patientRelationship.error = true;
            errorCopy.patientRelationship.text = "Campo requerido";
            doAppt = false;
          } else {
            errorCopy.patientRelationship.error = false;
            errorCopy.patientRelationship.text = "";
          }
          if (identityDocumentType === "") {
            errorCopy.identityDocumentType.error = true;
            errorCopy.identityDocumentType.text = "Campo requerido";
            doAppt = false;
          } else {
            errorCopy.identityDocumentType.error = false;
            errorCopy.identityDocumentType.text = "";
          }
          setErrors(errorCopy);
        }
        if (doAppt) {
          setIsSubmiting(true);
          let propertyType = null;
          let propertyTypeAdditional = null;
          if (
            initialData.colombusAddress.propertyType &&
            initialData.colombusAddress.propertyType?.id
          ) {
            propertyType = initialData.colombusAddress.propertyType;
          } else if (initialData.colombusAddress.propertyType) {
            propertyType = { id: initialData.colombusAddress.propertyType };
          }
          if (
            initialData.colombusAddress.propertyTypeAdditional &&
            initialData.colombusAddress.propertyTypeAdditional?.id
          ) {
            propertyTypeAdditional =
              initialData.colombusAddress.propertyTypeAdditional;
          } else if (initialData.colombusAddress.propertyTypeAdditional) {
            propertyTypeAdditional = {
              id: initialData.colombusAddress.propertyTypeAdditional,
            };
          }
          let cAdrress = {
            id: "",
            roadType: initialData.colombusAddress.roadType
              ? { id: initialData.colombusAddress.roadType }
              : null,
            streetField1: initialData.colombusAddress.streetField1,
            streetField2: initialData.colombusAddress.streetField2,
            streetField3: initialData.colombusAddress.streetField3,
            propertyNumber: initialData.colombusAddress.propertyNumber,
            propertyType: propertyType,
            propertyTypeAdditional: propertyTypeAdditional,
            unitNumber: initialData.colombusAddress.unitNumber,
          };
          const firma = sigCanvas.current
            .getTrimmedCanvas()
            .toDataURL("image/png");
          const base64result = firma.split(",")[1];
          let d = {
            source: sourceObj,
            appointmentStatus: hasCopayment ? "PendientePago" : "Pendiente",
            tipoPlan: initialData.tipoPlan,
            patient: {
              id: initialData.id,
              email: initialData.email,
              gender: initialData.gender,
              dateOfBirthday: moment(
                initialData.dateOfBirthday,
                "DD-MM-YYYY"
              ).format("DD-MM-YYYY"),
              nationality: initialData.nationality,
              phoneNumber: initialData.phoneNumber,
              phoneNumber2: initialData.phoneNumber2,
              bloodType: initialData.bloodType,
              ocupacion: initialData.ocupacion
                ? { id: initialData.ocupacion }
                : null,
              address: initialData.address,
              account: initialData.account,
              company: initialData.account?.partner?.company,
              name: initialData.name.toUpperCase(),
              lastName: initialData.lastName.toUpperCase(),
              middleName: initialData.middleName.toUpperCase(),
              seccondSurname: initialData.seccondSurname.toUpperCase(),
              localidad: initialData.location
                ? { id: initialData.location }
                : null,
              neighborhood: initialData.neighborhood,
              identityDocumentType: { id: initialData.identityDocumentType },
              documentNumber: initialData.documentNumber,
              country: initialData.country ? { id: initialData.country } : null,
              municipio: initialData.municipio
                ? { id: initialData.municipio }
                : null,
              state: initialData.state ? { id: initialData.state } : null,
              patientRelationship: initialData.patientRelationship
                ? { id: initialData.patientRelationship }
                : null,
              colombusAddress: cAdrress,
              countryBirth: initialData.countryBirth
                ? { id: initialData.countryBirth }
                : null,
              titular: initialData.titular ? initialData.titular : null,
              eps: initialData.eps.id ? initialData.eps : null,
              tipoPlan: initialData.tipoPlan,
            },
            eps: initialData.eps.id ? initialData.eps : null,
            schedule: initialData.schedule,
            especialty: {
              id: initialData.especialidadId,
            },
            peso: initialData.peso ? initialData.peso : 0.0,
            talla: initialData.talla ? initialData.talla : 0.0,
            motivoConsulta: initialData.sintomas,
            choiceType: choiceTypeInput,
            account: { id: idAccount },
            legalWarnings: [
              {
                acceptPatient: "approved",
                legalWarningType: "InformedConsent",
                dataRecord: dataRecord,
                url_photo: base64result,
                legalAgent: aceptacionAcudiente
                  ? {
                      fullName: fullName,
                      documentNumber: documentNumber,
                      identityDocumentType: {
                        id: identityDocumentType,
                      },
                      patientRelationship: {
                        id: patientRelationship,
                      },
                    }
                  : null,
              },
            ],
          };
          //console.log(d)
          //console.log(JSON.stringify(d))
          getTokenExternal(initialData.account?.partner?.company)
            .then((resp) => {
              Post({
                url: ADD_APPOINTMENT,
                data: d,
                access_token: resp.data.access_token,
                header: true,
              })
                .then((response) => {
                  setIsSubmiting(false);
                  if (response.data.state) {
                    setReservadoExitosamente(true);
                    if (hasCopayment) {
                      setOpenModalPago(true);
                      setObjPayment(response.data.data.payment);
                    }
                  } else {
                  }
                })
                .catch((error) => {
                  //console.log(error)
                  setShowModalServer(true);
                  setErrorServer(error?.response);
                  setIsSubmiting(false);
                });
            })
            .catch((e) => {
              setShowModalServer(true);
              setErrorServer(e?.response);
              setIsSubmiting(false);
            });
        }
      }
    } else {
      setDeclined(true);
      handleClose();
    }
  };

  const onClickGoPayment = () => {
    setOpenModalPago(false);
    if (!objPayment || objPayment === undefined) {
      setFailPayment(true);
    } else {
      setFailPayment(false);
      setPayment(objPayment);
      window.open(objPayment.url, "_blank", "noopener,noreferrer");
    }
  };
  const getTipoDocumento = (value) => {
    let arr = tipoDocumentoOpt
      .filter((el) => el.code === "AS" || el.code === "MS")
      .map((e) => e.id);
    return arr.includes(parseInt(value));
  };
  const [hasLength, setHasLength] = useState(10);
  const getLengthDN = (code) => {
    switch (code.toUpperCase()) {
      case "CE":
        return 12;
      case "CD":
      case "PA":
      case "SC":
        return 16;
      case "PE":
        return 15;
      case "RC":
      case "TI":
        return 11;
      case "CN":
        return 9;
      case "MS":
        return 12;
      default:
        return 10;
    }
  };

  const checkValidationDocument = (value) => {
    if (getTipoDocumento(identityDocumentType)) {
      setErrors((err) => ({
        ...err,
        documentNumber: {
          error: true,
          text: "Campo requerido",
        },
      }));
      setAllowDoAppt(false);
    } else {
      if (value === "") {
        setErrors((err) => ({
          ...err,
          documentNumber: {
            error: true,
            text: "Campo requerido",
          },
        }));
        setAllowDoAppt(false);
      } else if (value.length < 5) {
        setErrors((err) => ({
          ...err,
          documentNumber: {
            error: true,
            text: "Debe tener una longitud mínima de 5 caracteres",
          },
        }));
        setAllowDoAppt(false);
      } else if (value.length > hasLength) {
        setErrors((err) => ({
          ...err,
          documentNumber: {
            error: true,
            text: `Debe tener una longitud máxima de ${hasLength} caracteres`,
          },
        }));
        setAllowDoAppt(false);
      } else {
        setErrors((err) => ({
          ...err,
          documentNumber: {
            error: false,
            text: "",
          },
        }));
        setAllowDoAppt(true);
      }
    }
  };

  //declinado
  const [openConfirmacionDeclinar, setOpenConfirmacionDeclinar] =
    useState(false);
  const handleCloseDeclinar = () => {
    setOpenConfirmacionDeclinar(false);
  };
  const handleDeclinarAppointment = () => {
    setOpenConfirmacionDeclinar(false);
    handleMakeAppointment(false);
  };

  return failPayment ? (
    <Row className="h-100vh">
      <Col xs="12" md={{ span: 4, offset: 4 }}>
        <Card>
          <Card.Body>
            <div className="text-center">
              <p>
                Sr(a). Usuario: Su cita no pudo ser agendada, por favor realice
                nuevamente el proceso de agendamiento.
              </p>
              <Button
                type="button"
                variant="secondary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Iniciar nuevamente
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  ) : (
    <>
      {reservadoExitosamente && !hasCopayment ? (
        <Row className="h-100vh">
          <Col xs="12" md={{ span: 4, offset: 4 }}>
            <Card>
              <Card.Body>
                <div className="text-center">
                  <h5>{t("citas_pendiente_aprobacion")}</h5>
                  <p>{configuration?.approvedServiceText ?? ""}</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        !reservadoExitosamente && (
          <Card className="mb-2">
            <Card.Header className="text-center">
              <h5 className="text">{t("confirmar_servicio")}</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Formik
                    initialValues={initialData}
                    validationSchema={shemaValidateStepOne}
                    onSubmit={(values) => {
                      //console.log(values)
                      setChoiceTypeInput(values.choiceType);
                      setShow(true);
                    }}
                  >
                    {({
                      errors,
                      handleSubmit,
                      setFieldValue,
                      setFieldError,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div className="mb-4 text-right">
                          <Button
                            type="button"
                            variant="primary"
                            onClick={prev}
                            className="btn1"
                          >
                            {t("regresar")}
                          </Button>{" "}
                          <Button
                            type="submit"
                            variant="primary"
                            className="btn1"
                          >
                            {t("confirmar")}
                          </Button>
                        </div>
                        <Row>
                          <Col xs="12" md="6">
                            <h4 className="color-blue-dark text-style">
                              {t("informacion_medico")}
                            </h4>
                            <Row>
                              <Col xs="12" md="12">
                                <div className="mb-2">
                                  <strong>{t("medico")}: </strong>
                                  <label className="text-secondary">
                                    {initialData.doctorName}
                                  </label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col xs="12" md="6">
                            <h4 className="color-blue-dark text-style">
                              {t("paciente_informacion")}
                            </h4>
                            <Row>
                              <Col xs="12" md="12">
                                <div className="mb-2">
                                  <strong>{t("paciente")}: </strong>
                                  <label className="text-secondary">
                                    {`${initialData.name} ${initialData.middleName} ${initialData.lastName} ${initialData.seccondSurname}`}
                                  </label>
                                </div>
                              </Col>
                              <Col xs="12" md="12">
                                <div className="mb-2">
                                  <strong>{t("Telefono")}: </strong>
                                  <label className="text-secondary">
                                    {initialData
                                      ? initialData.phoneNumber
                                      : "-"}
                                  </label>
                                </div>
                              </Col>
                              <Col xs="12" md="12">
                                <div className="mb-2">
                                  <strong>{t("Correoelectronico")}: </strong>
                                  <label className="text-secondary">
                                    {initialData ? initialData.email : "-"}
                                  </label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col>
                            <h4 className="color-blue-dark text-center mb-4 text-style">
                              {t("informacion_servicio")}
                            </h4>
                            <Row>
                              <Col xs="12" md="6">
                                <Row>
                                  <Col xs="12" md="12">
                                    <div className="mb-2">
                                      <strong>{t("tipo_servicio")}: </strong>
                                      <label className="text-secondary">
                                        {t("telemedicina")} ({t("videollamada")}
                                        )
                                      </label>
                                    </div>
                                  </Col>
                                  <Col xs="12" md="12">
                                    <div className="mb-2">
                                      <strong>{t("especialidad")}: </strong>
                                      <label className="text-secondary">
                                        {initialData.especialidadName}
                                      </label>
                                    </div>
                                  </Col>
                                  <Col xs="12" md="12">
                                    <div className="mb-2">
                                      <strong>{t("dia_hora")}: </strong>
                                      <label className="text-secondary">
                                        {moment(
                                          initialData.schedule.hourInit,
                                          "DD-MM-YYYY HH:mm:ss"
                                        ).format("DD-MM-YYYY HH:mm")}
                                      </label>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                              {configuration?.informationTelemedicine && (
                                <Col xs="12" md="6">
                                  <div className="text-center">
                                    <h6>{t("telemedicina")}</h6>
                                    <p className="font-size-08rem">
                                      {configuration.informationTelemedicine}
                                    </p>
                                  </div>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <div className="mt-3 text-right">
                          <label className="d-block font-weight-bold mr-5">
                            {t("dia_hora_debido_a")}:
                          </label>
                          <label
                            className={`mr-5 text-color-input d-block ${
                              errors.choiceType ? "color-red" : ""
                            } text-secondary`}
                          >
                            {t("consulta_mas_cerca")}
                            <Field
                              type="radio"
                              name="choiceType"
                              value="closerAppointment"
                              className="ml-3 radio-form"
                            />
                          </label>
                          <label
                            className={`mr-5 text-color-input ${
                              errors.choiceType ? "color-red" : ""
                            } text-secondary`}
                          >
                            {t("cita_mejor_adapta")}
                            <Field
                              type="radio"
                              name="choiceType"
                              value="preferAppointment"
                              className="ml-3 radio-form"
                            />
                          </label>
                          {errors.choiceType && (
                            <div className="invalid-feedback d-block">
                              {errors.choiceType}
                            </div>
                          )}
                        </div>
                        <div className="mt-4 text-right">
                          <Button
                            type="button"
                            variant="primary"
                            onClick={prev}
                            className="btn1"
                          >
                            {t("regresar")}
                          </Button>{" "}
                          <Button
                            type="submit"
                            variant="primary"
                            className="btn1"
                          >
                            {t("confirmar")}
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Col>
              </Row>
            </Card.Body>

            <Modal
              show={show}
              onHide={handleClose}
              centered
              className="border-0"
              size="lg"
              backdrop="static"
              keyboard={false}
            >
              <Modal.Body className="p-2">
                <div className="position-relative overflow-hidden">
                  {isSubmitting && <SimpleLoad />}
                  <h5 className="text-uppercase">
                    {t("consentimiento_telesalud")}
                  </h5>
                  <hr />
                  <ConsentimientoTeleSalud
                    namePaciente={`${initialData.name} ${initialData.middleName} ${initialData.lastName} ${initialData.seccondSurname}`}
                    noDocumento={`${
                      initialData.identityDocumentTypeModel.code
                    } ${
                      initialData.documentNumber
                        ? `: ${initialData.documentNumber}`
                        : ""
                    }`}
                    nameDoctor={initialData.doctorName}
                    nameAccount={nameAccount}
                    configuration={configuration}
                    initialData={initialData}
                    setDataRecord={setDataRecord}
                  />
                  <Row>
                    <Col xs="12" md={{ span: 6, offset: 3 }}>
                      <div className="border">
                        <SignatureCanvas
                          penColor="blue"
                          ref={sigCanvas}
                          canvasProps={{
                            width: 500,
                            height: 200,
                            border: "1px solid #000",
                          }}
                        />
                        {errors.firma.error && (
                          <span className="text-danger">
                            {errors.firma.text}
                          </span>
                        )}
                      </div>
                      <div className="w-100 text-right">
                        <Button
                          variant="outline-secondary"
                          onClick={clear}
                          size="sm"
                        >
                          Limpiar
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <div>
                    <Form.Check
                      className="color-354052 font-size-08rem font-weight-bold-600"
                      type="checkbox"
                      label="Aceptación de consentimiento por acudiente"
                      checked={aceptacionAcudiente}
                      onChange={(e) => {
                        setAceptacionAcudiente(e.target.checked);
                        if (!e.target.checked) {
                          setIdentityDocumentType("");
                          setDocumentNumber("");
                          setPatientRelationship("");
                          setFullName("");
                        }
                      }}
                    />
                  </div>
                  {aceptacionAcudiente && (
                    <Row>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("tipo_documento")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            className={`input-form ${
                              errors.identityDocumentType.error && "error"
                            }`}
                            value={identityDocumentType}
                            onChange={(e) => {
                              setIdentityDocumentType(e.target.value);
                              let aux = tipoDocumentoOpt.filter(
                                (el) => el.id === parseInt(e.target.value)
                              )[0];
                              setHasLength(getLengthDN(aux.code));
                            }}
                          >
                            <option value="">{t("Seleccionar")}</option>
                            {tipoDocumentoOpt.map((item, i) => (
                              <option
                                value={item.id}
                                key={i}
                              >{`${item.code} : ${item.name}`}</option>
                            ))}
                          </Form.Control>
                          {errors.identityDocumentType.error && (
                            <div className="invalid-feedback d-block">
                              {errors.identityDocumentType.text}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("documento_identidad")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className={`input-form ${
                              errors.documentNumber.error && "error"
                            }`}
                            name={documentNumber}
                            onChange={(e) => setDocumentNumber(e.target.value)}
                            onBlur={(e) =>
                              checkValidationDocument(e.target.value)
                            }
                          />
                          {errors.documentNumber.error && (
                            <div className="invalid-feedback d-block">
                              {errors.documentNumber.text}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Nombre completo{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className={`input-form text-uppercase ${
                              errors.fullName.error && "error"
                            }`}
                            name={fullName}
                            onChange={(e) =>
                              setFullName(e.target.value.toUpperCase())
                            }
                          />
                          {errors.fullName.error && (
                            <div className="invalid-feedback d-block">
                              {errors.fullName.text}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Parentesco <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            className={`input-form ${
                              errors.patientRelationship.error && "error"
                            }`}
                            name={patientRelationship}
                            onChange={(e) =>
                              setPatientRelationship(e.target.value)
                            }
                          >
                            <option value="">Seleccionar</option>
                            {tipoPacientes.map((item, i) => (
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </Form.Control>
                          {errors.patientRelationship.error && (
                            <div className="invalid-feedback d-block">
                              {errors.patientRelationship.text}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                  <div className="mt-3">
                    <Form.Group className="text-center">
                      <Form.Check
                        type="checkbox"
                        label={t("acepto")}
                        className="checked-terms"
                        onChange={(e) => setCheckedTerms(e.target.checked)}
                      />
                    </Form.Group>
                  </div>

                  <Row className="text-center">
                    <Col>
                      <Button
                        variant="link"
                        className="text-danger font-weight-bold"
                        onClick={(e) => setOpenConfirmacionDeclinar(true)}
                      >
                        Declinar
                      </Button>{" "}
                      <Button
                        variant="outline-success"
                        className="ok-buttom"
                        onClick={(e) => handleMakeAppointment(true)}
                        disabled={!checkedTerms}
                      >
                        Aceptar
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Modal.Body>
            </Modal>
            <ComponentModalErrorSever
              show={showModalServer}
              handleClose={handleCloseModalServer}
              error={errorServer}
            />
          </Card>
        )
      )}
      <ModalInformacionParaPago
        cita={citaCostoMoneda}
        open={openModalPago}
        setOpen={setOpenModalPago}
        onClickGoPayment={onClickGoPayment}
        setPaymentStatus={setPaymentStatus}
        configuration={configuration}
      />
      <ModalHandleDeclinado
        open={openConfirmacionDeclinar}
        setOpen={setOpenConfirmacionDeclinar}
        handleDeclinarAppointment={handleDeclinarAppointment}
        handleCloseDeclinar={handleCloseDeclinar}
      />
    </>
  );
}

export default withTranslation()(StepTreeCuenta);
